<template>
  <v-container fluid class="py-6 category-page">
    <v-row justify="center" class="mb-8">
      <v-col cols="12" md="8" class="text-center">
        <h1 class="display-1 font-weight-bold gradient-title">🛍️ Categories</h1>
        <p class="subtitle-1 text-white">Browse and vote for your favourite products!</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col
          v-for="category in categories"
          :key="category.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="d-flex"
      >
        <v-card class="category-card" elevation="10">
          <v-img :src="category.image" height="200px" cover class="rounded-top" />
          <v-card-title class="headline text-white">{{ category.title }}</v-card-title>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn
                class="vote-now-btn"
                color="primary"
                @click="goToCategory(category.id)"
            >
              Vote Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CategoriesView",
  data() {
    return {
      categories: [
        {
          id: 1,
          title: "Best Skincare",
          image: "https://images.unsplash.com/photo-1617201488685-195a5b8f84db?auto=format&fit=crop&w=600&q=80",
        },
        {
          id: 2,
          title: "Health Supplements",
          image: "https://images.unsplash.com/photo-1600172454520-1c8a9649eac2?auto=format&fit=crop&w=600&q=80",
        },
        {
          id: 3,
          title: "Personal Care",
          image: "https://images.unsplash.com/photo-1600180758890-6a0cb9be16b1?auto=format&fit=crop&w=600&q=80",
        },
        {
          id: 4,
          title: "Mother & Baby",
          image: "https://images.unsplash.com/photo-1585577529543-ec8160dd0a5b?auto=format&fit=crop&w=600&q=80",
        },
      ],
    };
  },
  methods: {
    goToCategory(categoryId) {
      this.$router.push({ name: "CategoryProducts", params: { id: categoryId } });
    },
  },
};
</script>

<style scoped>
.category-page {
  min-height: 100vh;
}

.gradient-title {
  background: linear-gradient(to right, #ffffff, #ffeb3b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.category-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}
.category-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.vote-now-btn {
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.3s ease;
}
.vote-now-btn:hover {
  background-color: #ffffff !important;
  color: #1976d2 !important;
}
</style>
